import { useCohort } from "@/components/user-context";
import { experiments, useExperiment } from "@/utils/experiment";

import { LoggedInJiraNewUser } from "../components/logged-in-jira-new-user";

import { CurrentProductJoinableUser } from "./current-product-joinable-user";
import { CurrentProductUser } from "./current-product-user";
import { LoggedInJiraFreeExistingSitesUser } from "./existing-sites-user";
import { LoggedInJiraFreeManagedUser } from "./managed-user";
import { LoggedInJiraFreeWeekOneUser } from "./week-one-user";

export const LoggedInJiraFree = () => {
    const experiment = useExperiment(
        experiments.jiraContactAndCompanyExpandSiteActivation
    );

    const useContactExpandCohortLogic =
        experiment.type === "enrolled" && experiment.value;

    const cohort = useCohort(useContactExpandCohortLogic);

    if (useContactExpandCohortLogic) {
        if (cohort === "current-product-user") {
            return <CurrentProductUser />;
        }

        if (cohort === "current-product-joinable-user") {
            return <CurrentProductJoinableUser />;
        }

        return <LoggedInJiraNewUser />;
    }

    if (cohort === "new-user") {
        return <LoggedInJiraNewUser />;
    }

    if (cohort === "managed-user") {
        return <LoggedInJiraFreeManagedUser />;
    }

    if (cohort === "week-one-user") {
        return <LoggedInJiraFreeWeekOneUser />;
    }

    if (cohort) {
        return <LoggedInJiraFreeExistingSitesUser />;
    }

    return null;
};
